var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi } from './';
import { request } from './request';
import { WechatState } from './wechat';
import { config } from '../config/constants';
import { getState } from './state';
/**
 * 问卷的审核状态码
 */
export var AuditStatus;
(function (AuditStatus) {
    AuditStatus["pending"] = "0";
    AuditStatus["fullfilled"] = "1";
    AuditStatus["reject"] = "-1";
})(AuditStatus || (AuditStatus = {}));
/**
 * 问卷 的代理接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function formApi(target, data) {
    return proxyApi({ module: 'form', target, data });
}
/**
 * 获取单条问卷申请记录
 * @export
 * @param {string} formId
 * @param {string[]} items 组件name
 */
export function getSubmitResult(formId, items) {
    return formApi('SubmitResult', {
        formId,
        items,
    });
}
/**
 * 批量获取问卷申请记录
 * @export
 * @param {string[]} formIds 问卷ids
 * @param {number} [index=1]
 * @param {number} [size=20]
 */
export function getSubmitResults(formIds, index = 1, size = 20) {
    return formApi('SubmitResults', {
        formIds,
        index,
        size
    });
}
/**
 * 获取问卷提交次数
 * @export
 * @param {string[]} formIds 问卷ids
 */
export function getSubmitCounts(formIds) {
    return formApi('SubmitCounts', {
        formIds,
    });
}
/**
 * 获取打分问卷的分数结果
 * @remark 未开启问卷打分score为0
 * @param {string} formId
 */
export function getFormSubmitScore(formId) {
    return formApi('SubmitScore', {
        formId,
    });
}
/**
 * 查询问卷是否剩余提交次数
 * @export
 * @param {string} formId 问卷id
 */
export function checkWechatUnique(formId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = new FormData();
            const userInfo = getState(WechatState);
            if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.openid) && formId) {
                data.append('WechatAppId', config.appId);
                data.append('WechatOpenId', userInfo.openid);
                data.append('structureId', formId);
                const res = yield request.post(config.formOpen + '/submit/wechatunique', data);
                return res.code === 200;
            }
            return false;
        }
        catch (error) {
            return false;
        }
    });
}
/**
 * 获取问卷配置
 * @param {string} formId 问卷id
 */
export function getFormDetail(formId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield request.get(`${config.formOpen}/${formId}`);
    });
}
